// ไอคอน emoji บนหน้าเล่น: กลุ่มสัตว์ และประเภทของข้อความในบันทึกชีวิต

export const GROUP_ICON: Readonly<Record<string, string>> = {
  mammal: "🐾", bird: "🐦", reptile: "🦎", amphibian: "🐸", fish: "🐟", insect: "🐞", arachnid: "🕷️",
  crustacean: "🦀", mollusc: "🐚", myriapod: "🐛", worm: "🪱", cnidarian: "🪼", echinoderm: "⭐",
};

// กลุ่มย่อยที่หน้าตาต่างจากกลุ่มใหญ่ชัดเจน
const SUBGROUP_ICON: Readonly<Record<string, string>> = {
  "mammal.carnivore": "🐯", "mammal.ungulate": "🦌", "mammal.primate": "🐒", "mammal.rodent": "🐀", "mammal.bat": "🦇",
  "mammal.whale": "🐋", "mammal.marsupial": "🦘", "bird.raptor": "🦅", "bird.waterbird": "🦢", "bird.hornbill_woodpecker": "🦜",
  "reptile.snake": "🐍", "reptile.crocodile": "🐊", "reptile.turtle": "🐢", "fish.shark_ray": "🦈", "insect.butterfly": "🦋",
  "insect.bee_wasp": "🐝", "insect.ant_termite": "🐜", "insect.beetle": "🪲", "insect.fly": "🪰", "insect.grasshopper": "🦗",
  "arachnid.scorpion": "🦂", "mollusc.cephalopod": "🐙", "mollusc.gastropod": "🐌", "cnidarian.coral": "🪸",
};

export const groupIcon = (groupId: string | undefined) => (groupId && GROUP_ICON[groupId]) || "🐾";

/** ไอคอนของกลุ่มย่อย ถ้าไม่มีใช้ของกลุ่มใหญ่ */
export const subgroupIcon = (subgroupId: string | undefined) =>
  (subgroupId && SUBGROUP_ICON[subgroupId]) || groupIcon(subgroupId?.split(".")[0]);

// ดูจากคำในข้อความ เรียงจากเรื่องที่เจาะจงที่สุดก่อน
const RULES: readonly [RegExp, string][] = [
  [/รุ่นที่ \d|เริ่มต้นชีวิต|ลืมตาดูโลก|ฟักออก/, "✨"],
  [/อพยพ|บินไปราว|ว่ายไปราว|เดินทางไปราว|กระแสน้ำพาคุณ/, "🧭"],
  [/วางไข่|คลอดลูก|ออกลูก|ลูก \d|ไข่ \d/, "🥚"],
  [/คู่/, "💞"],
  [/ป่วย|ปรสิต|ติดเชื้อ|ไม่สบาย/, "🦠"],
  [/บาดเจ็บ|แผล|เจ็บ|กัด|ฉก/, "🩹"],
  [/นักล่า|ตะครุบ|โฉบ|จ้องมา|ซุ่ม/, "⚠️"],
  [/ฝน|พายุ|น้ำท่วม|ไฟป่า|หิมะ|แล้ง|ร้อนจัด|หนาว/, "🌦️"],
  [/ชาวบ้าน|ชาวประมง|อวน|เรือ|มนุษย์|คนกลุ่ม|ถนน|รถ/, "👣"],
  [/อดอาหาร|หิว/, "🍂"],
  [/กิน|อิ่ม|อาหาร|เหยื่อ|จับ/, "🍃"],
  [/โต|ช่วงวัย|ลอกคราบ|ดักแด้/, "🌱"],
  [/จากไป|หลับตาลง|ชีวิตของคุณจบ/, "🕯️"],
];

export function logIcon(text: string, subgroupId: string): string {
  return RULES.find(([re]) => re.test(text))?.[1] ?? subgroupIcon(subgroupId);
}
